import { cn } from "./lib/utils.js";

type BooroMarkProps = {
  className?: string;
  /** Accessible label. Omit for decorative marks next to a text wordmark. */
  label?: string;
};

/**
 * The BOORO wordmark: the rendered art from docs/product/Branding/brandkit.md,
 * not a text substitute. The brand export writes it in two inks; the surface
 * picks the one that reads on it.
 */
export function BooroWordmark({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex items-center", className)}>
      <img
        src="/brand/booro-wordmark-light.png"
        alt="BOORO"
        className="booro-wordmark-ink booro-wordmark-ink--light h-[22px] w-auto"
      />
      <img
        src="/brand/booro-wordmark-dark.png"
        alt="BOORO"
        className="booro-wordmark-ink booro-wordmark-ink--dark h-[22px] w-auto"
      />
    </span>
  );
}

/**
 * The OO-eyes app mark from docs/product/Branding/brandkit.md.
 * Fixed brand colors keep the mark identical on light and dark surfaces.
 */
export function BooroMark({ className, label }: BooroMarkProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={cn("size-11 shrink-0", className)}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <circle cx="32" cy="32" r="32" fill="#0A1024" />
      <g fill="#F8F6EC">
        <ellipse cx="22.5" cy="36" rx="7" ry="10" />
        <ellipse cx="41.5" cy="36" rx="7" ry="10" />
      </g>
      <g fill="#0A1024">
        <ellipse cx="22.5" cy="38" rx="2.4" ry="4.2" />
        <ellipse cx="41.5" cy="38" rx="2.4" ry="4.2" />
      </g>
      <g stroke="#A7FF3F" strokeWidth="3.2" strokeLinecap="round">
        <path d="M15.5 18.5 19 14" />
        <path d="M48.5 18.5 45 14" />
      </g>
    </svg>
  );
}
